export default "__VITE_ASSET__uoKpzkJ9__"